import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "app-potting-instructions-form",
  templateUrl: "./potting-instructions-form.component.html"
})
export class PottingInstructionsFormComponent {
  @Input() options: PottingInstructionsOptions;
  @Input() treatment: FormGroup;

  public get pottingInstructions(): FormGroup {
    return <FormGroup>this.treatment.get("pottingInstructions");
  }

  public get potType(): number {
    return this.pottingInstructions.value.potType;
  }

  public get substrate(): number {
    return this.pottingInstructions.value.substrate;
  }

  public get irrigation(): number {
    return this.pottingInstructions.value.irrigation;
  }

  public get fertigation(): number {
    return this.pottingInstructions.value.fertigation;
  }

  constructor() { }

  public copyValueFrom(copyArgs: PottingInstructionsCopyArgs) {
    this.pottingInstructions.patchValue(copyArgs);
    this.pottingInstructions.updateValueAndValidity();
  }
}

export interface PottingInstructionsCopyArgs {
  potType: number;
  substrate: number;
  irrigation: number;
  fertigation: number;
}

export interface PottingInstructionsOptions {
  potTypes: PotTypeDisplay[];
  substrates: SubstrateDisplay[];
  irrigations: IrrigationDisplay[];
  fertigations: FertigationDisplay[];
}

export interface PotTypeDisplay {
  id: number;
  display: string;
}

export interface SubstrateDisplay {
  id: number;
  display: string;
}

export interface IrrigationDisplay {
  id: number;
  display: string;
}

export interface FertigationDisplay {
  id: number;
  display: string;
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/potting-instructions/potting-instructions-form/potting-instructions-form.component.ts